import messages from './netbank-login-disabled-lang.json';
import branchAtmWidgetWrapper from '../../branch-atm-widget-wrapper/branch-atm-widget-wrapper.vue';
export default {
	data() {
		return {};
	},
	props: {
		atmBranchSearchUrl: {
			required: true
		},
		gmapsApiKey: {
			type: String,
			required: true
		}
	},
	components: {
		branchAtmWidgetWrapper
	},
	i18n: { messages }
};
